<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="线上订单 > 咨询订单列表" style="height:auto" >
      <el-form :inline="true" :model="order" class="demo-form-inline">
        <div>
        <el-form-item label="登录用户名">
          <el-input size="mini" v-model.trim="order.moblie" placeholder="登录用户名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
        </el-form-item>
        </div>
      </el-form>
      <el-table
        :data="data"
        size="small"
        @cell-dblclick="mainTabClick"
        :row-key="getRowKeys"
        :expand-row-keys="expands"
        @expand-change="openExpand"
        border>
        <el-table-column 
          fixed
          type="expand"
          Scoped slot>
          <template slot-scope="props">
            <el-tabs v-model="activeName" @tab-click="handleClick(props.row)" style="width:100%">
              <el-tab-pane label="订单详情" name="first">
                <el-table 
                :data="props.row.detailList"
                :row-class-name="tableRowName"
                @cell-dblclick="subTabClick"
                 border style="height:100%;">
                  <el-table-column
                    fixed
                    prop="manufacturerNumber"
                    show-overflow-tooltip
                    label="产品型号"
                    width="210">
                  </el-table-column>
                  <el-table-column
                    prop="brandName"
                    show-overflow-tooltip
                    label="品牌"
                    width="200">
                  </el-table-column>
                  <el-table-column
                    prop="buyCount"
                    show-overflow-tooltip
                    label="购买数量"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="targetPrice"
                    label="目标价格"
                    width="150">
                  </el-table-column>
                  <el-table-column prop="batch" label="批次"
                    width="150"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="workDate"
                    label="发货期限"
                    width="160">
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    label="备注">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="订单编号"
          show-overflow-tooltip
          width="208">
        </el-table-column>
        <el-table-column
          label="用户名"
          prop="userName"
          show-overflow-tooltip
          width="150">
        </el-table-column>
        <el-table-column
          label="联系电话"
          prop="userMobile"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="邮箱"
          prop="email"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="qq"
          label="QQ">
        </el-table-column>
        <el-table-column
          prop="ip"
          label="ip">
        </el-table-column>
        <el-table-column
          prop="ipAddress"
          label="所在ip地址">
        </el-table-column>
        <el-table-column
          prop="createDate"
          show-overflow-tooltip
          label="下单时间">
        </el-table-column>
        <el-table-column
          prop="realName"
          show-overflow-tooltip
          label="接待客服">
        </el-table-column>
        <el-table-column prop="remark" label="备注"
          show-overflow-tooltip>
          <template scope="scope" >
            <span v-if="scope.row.id === cellRemark.tabMainIndex && cellRemark.tabMainLabel === '备注'">
              <el-input size="small"
               v-model="cellRemark.remark.main" placeholder="请输入内容" @blur="handleRemarkEdit(scope.row)"/>
            </span>
            <template v-else>
              <span>{{scope.row.remark}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          width="140"
          label="操作" >
          <template slot-scope="scope">
            <el-button
              size="mini"
              v-if="scope.row.realName == null"
              @click="linkCustomer(scope.row)">关联客服</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      expands: [],
      orderNos: '',
      loading: false,
      productOtions:[],
      roleId: this.user.getUserData().roleId,
      optionItem: {},
      formLabelWidth: '140px',
      dialogFormVisible:false,
      editorMehotd: 1,
      dialogOrderFormVisible: false,
      activeName: 'first',
      addressList: [],
      payList:[],
      getRowKeys: (row) => {
        return row.orderNo   
      },
      cellRemark: {
        tabMainIndex : '',
        tabMainLabel : '',
        remark: {
          main: '',
        },
      },
      order: {
        payType: '',
        orderNo: '',
        token: this.user.getToken()
      },
      link: {
        id: '',
        token: this.user.getToken()
      },
      
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
    };
  },
  components: {
    pagination
  },
  methods: {
    mainTabClick: function(row, column, cell, event) {
      console.log(JSON.stringify(row))
      this.cellRemark.tabMainIndex = row.id
      this.cellRemark.tabMainLabel = column.label
      this.cellRemark.remark.main = row.remark
    },
    linkCustomer: function(val) {
      // 判断该订单下是否存在需要发货的字订单
      this.http.post(
      '/order/consult/link', 
      {
        id: val.id,
        token: this.user.getToken()
      }, res => {
        if (res.success) {
          // 返回正确的处理
          this.getOrderData();
        } else {
          // 返回错误的处理
          this.$message.error(res.message)
        }
      });
    },
    handleClick(sval) {
      if (this.activeName =='six') {
        this.historyOrder.userId = sval.userId
        this.getHistoryOrderData()
      }
    },
    openExpand: function(row, rowList) {
      this.activeName = 'first'
      this.loading = true
      var that = this
      if (rowList.length) { // 只展开一行//说明展开了
        that.expands = []
        if (row) {
          that.expands.push(row.orderNo)// 只展开当前行id
        }
      //  this.tablaData(row.eqId)  这里可以调用接口数据渲染
      } else { // 说明收起了
        that.expands = []
      }
    },
    handleRemarkEdit: function(row) {
      if (this.cellRemark.remark.main != row.remark) {
        this.http.post(
          '/order/consult/remark',
          {
            id: row.id,
            remark: this.cellRemark.remark.main,
            token: this.user.getToken()
          }, res => {
            if (res.success) {
              this.cellRemark.tabMainIndex = null
              this.cellRemark.tabMainLabel = '' 
              this.cellRemark.remark.main = '' 
              // 返回正确的处理
              this.getOrderData();
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
          });
      }else {
        this.cellRemark.tabMainIndex = null
        this.cellRemark.tabClickLabel = '' 
        this.cellRemark.remark.main = row.remark
      }
    },
    getOrderData: function() {
      this.optionItem = this.common.extend(this.order, this.pagination);
      // 初始化默认加载菜单
      this.http.post(
        '/order/consult/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    onSubmit: function() {
      this.getOrderData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getOrderData()
    },
  },
  mounted: function() {
    this.getOrderData();
  },
};
</script>


<style>
.invoice-css {
  padding: 10px 0 20px 0; width: 60%; text-align:center;
}
.el-table th {
  background: #F5F7FA;
}
.el-table__expanded-cell {  
  padding: 0px 0px 15px 47px !important;
}
.el-tabs {
  border:1px solid #eee;
}
.el-tabs__nav {
  padding: 0 20px;
}
.el-tabs__active-bar {
  margin-left: 20px;
}
.el-input--suffix .el-input__inner {
  padding-right: 16px;
}

.demo-table-expand {
  font-size: 0;
}
.el-form-item__content {
  line-height: none;
}
.del_line::after {
	content: no-open-quote;
	position: absolute;
	margin-top: 24px;
	left: 60px;
	width: 75%;
	border-bottom: 1px solid #ccc;
}
.del_refund_line::after {
	content: no-open-quote;
	position: absolute;
	margin-top: 24px;
	left: 60px;
	width: 75%;
	border-bottom: 1px dashed #F56C6C;
}
.el-table .efficacy-row {
  color: #ccc !important;
}
.el-table .warning-row {
  background: #eee;
}
.el-table .nofollow-row {
  background: #F2F6FC;
}
.el-table .danger-row {
  background: #F56C6C;
}
.el-table .transparent-row {
  background: #F2F6FC;
}
.el-table .processing-row {
  background:rgb(254, 240, 240);
}
.el-table .remind-row {
  background: rgb(253, 246, 236) !important;
}
.el-table .success-row {
  background: #f0f9eb !important;
}
.el-table .success-refund{
  background: #f5f7fa !important;
}
.el-table .success-paid{
  background:#fff !important;
}
.el-table .success-over {
  background: #ecf5ff !important;
}
.el-table .cell {
  line-height: 24px !important;
}
.el-button+.el-button {
    margin-left: 0px !important;
}
.el-table .hover-row>td {
  background: Transparent !important;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0 !important;
  padding: 0 40px;
  width: 50%;
}
.el-form-item__content {
  line-height: none;
}
.invoiceCss {
  padding: 0 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/order/orderConsultAllList.vue